var DownloadImage = (function() {

   let self;

   return {

      config: {
         instaBlockClass: '.js-contest-user',
         imageClass: '.js-profile-img',
         usernameClass: '.contest-list__name a'
      },

      vars: {},

      init: function() {
         self = this
         self.initVars();
         self.attachEventListeners();
      },

      initVars: function() {
         self.vars = {
            array: []
         };
      },

      attachEventListeners: function() {
         self.attachDomLoadEventListener();
      },

      attachDomLoadEventListener: function () {
         $(document).ready(function () {
             self.getRender();
         })
      },

      getRender: function () {

         let instaBlock = document.querySelectorAll('.js-contest-user');

         instaBlock.forEach(function(item) {
            let username = item.querySelector(self.config.usernameClass).textContent.replace('@', '');
            let image = $(self.config.imageClass + '_' + username)

            if (self.vars.array.indexOf(username) === -1) {
               $.ajax({
                   url: "https://www.instagram.com/" + username + "?__a=1",
                   type:'post',
                   success:function(response) {
                       console.log(username);
                       image.attr('src', response.graphql.user.profile_pic_url);
                   }
               });

               self.vars.array.push(username)
            }
         })

      },

   }
})();
var Likes = (function() {

   let self;

   return {
      
      config: {
         likeCountContainerClass: '.contest-list__vote',
         buttonLikeClass: '.contest-list__btn',
         iconHeardClass: '.icon-heart',
         userContainerClass: '.user_',
      },

      vars: {},

      init: function() {
         self = this;
         self.initVars();
         self.attachEventListeners();
      },

      initVars: function () {
         self.vars = {
            buttonLike: $(self.config.buttonLikeClass),
            iconHeard: $(self.config.iconHeardClass)
         };
     },

     attachEventListeners: function() {
         self.attachClickButtonLikeEventListener();
         self.attachClickIconHeardEventListener();
     },

     attachClickButtonLikeEventListener: function() {
         self.vars.buttonLike.click(function(event) {

            let button = event.target;
            let countLikes = button.getAttribute('data-like-count');
            let userId = button.getAttribute('data-user-id');
            let postId = event.target.getAttribute('data-post-id');

            if(!self.isVoted(postId)) {
               self.setLike(userId, postId);
               self.changeLikeAjax(userId, countLikes);
            }
         })
     },

     attachClickIconHeardEventListener: function() {
         self.vars.iconHeard.click(function(event) {

            let iconHeard = event.target;
            let countLikes = iconHeard.getAttribute('data-like-count');
            let userId = iconHeard.getAttribute('data-user-id');
            let postId = iconHeard.getAttribute('data-post-id');

            if(!self.isVoted()) {
               self.setLike(userId, postId);
               self.changeLikeAjax(userId, countLikes);
            }
         })
     },

     setLike: function(userId, postId) {
         $.ajax({
            method: "GET",
            url: "like.php",
            data: { 
               id: Number(userId), 
            }
         })
         .done(function(data) {
             self.iHaveAlreadySeenYouSomewhere(postId);
         }); 
     },

     changeLikeAjax: function(userId, countLikes) {
         let userContainer = document.querySelector(self.config.userContainerClass + userId);
         let likes = userContainer.querySelector(self.config.likeCountContainerClass)

         likes.textContent = Number(countLikes) + 1;
     },

     iHaveAlreadySeenYouSomewhere: function(postId) {
         localStorage.setItem(postId, true);
         sessionStorage.setItem(postId, true);
     },

     isVoted: function(postId) {

        if (window.localStorage && localStorage.getItem(postId)) {
           return true
        }

        if (window.sessionStorage && sessionStorage.getItem(postId)) {
           return true
        }

        return false
     }

   }
})();

var Popups = (function() {

    let self;

    return {

        config: {
            popupClass: '.winners-popup',
            popupOpenButtonClass: '.js-popup-init',
            popupCloseButtonClass: '.js-close-btn'
        },

        vars: {},

        init: function() {
            self = this;
            self.initVars();
            self.winnersPopupOpen();
            self.winnersPopupClose();
            console.log('Popup init');
        },

        initVars: function () {
            self.vars = {
                popupWindow: $(self.config.popupClass),
                popupOpenButton: self.config.popupOpenButtonClass,
                popupCloseButton: self.config.popupCloseButtonClass
            };
        },
        winnersPopupOpen: function() {
            $(document).on('click', self.vars.popupOpenButton, function(e){
                e.preventDefault();
                self.vars.popupWindow.addClass('active');
                $('#viqeo').prepend(self.codeAppend());
            });
        },
        winnersPopupClose: function() {
            $(document).on('click', self.vars.popupCloseButton, function(e){
                e.preventDefault();
                self.vars.popupWindow.removeClass('active');
                $('#viqeo .append').remove();
            });
        },
        codeAppend: function() {
            return ' <div class="append"><script async src="https://cdn.viqeo.tv/js/vq_starter.js"></script>\n' +
                '        <div style="width:100%;height:0;position:relative;padding-bottom: 57%;display: inline-block;" class="viqeo-embed viqeo-horizontal viqeo-embed--124d0924e95000c6a3ac" data-vnd="124d0924e95000c6a3ac" data-profile="876" data-aspectRatio="0.5620608899297423">\n' +
                '            <iframe src="https://cdn.viqeo.tv/embed/?vid=124d0924e95000c6a3ac" width="100%" height="100%" style="position:absolute;" frameBorder="0" allowFullScreen controls="controls"></iframe>\n' +
                '        </div></div>'
        }
    }
})();

var InfinityScroll = (function() {

    let self;
 
    return {
       
       config: {
          buttonInitInfinityClass: ".js-infinity",
          listWithUsersClass: ".contest-list",
          filterId2: "#switch02",
          filterId1: "#switch01",
          offset: 0,
          limit: 9,
          isFilter: 0,
          mobileBtnClass: '.btn-mobile',
          headerClass: '.feature-block',
          footerClass: '.fixed-footer',
          footerFlag: false
       },
 
       vars: {},
 
       init: function() {
          self = this;
          self.initVars();
          self.attachEventListeners();
          self.scrollClick();
          self.toggleMobileMenu();
          //self.scrollWindow();
       },
 
       initVars: function () {
          self.vars = {
             buttonInitInfinity: $(self.config.buttonInitInfinityClass),
             listWithUsers: $(self.config.listWithUsersClass),
             filter1: $(self.config.filterId1),
             filter2: $(self.config.filterId2),
             mobileBtn: $(self.config.mobileBtnClass),
             toggleFlag: false,
             headerHeight: $(self.config.headerClass.outerHeight)

          };
        },
 
        attachEventListeners: function() {
             self.attachDocumentReadyEventListener();
             self.attachButtonInitInfinityEventListener();
             self.attachFilterEventListener();
        },
 
        attachDocumentReadyEventListener: function() {
          $(document).ready(function(event) {
             self.loadingData(true);
          })
        },

        attachButtonInitInfinityEventListener: function() {
          self.vars.buttonInitInfinity.click(function(event) {
             self.loadingData(false);
          })
        },
 
        attachFilterEventListener: function() {
          self.vars.filter2.click(function(event) {
             self.config.isFilter = 1;
             self.config.offset = 0;
             $('.js-contest-user').remove()
             self.loadingData(true);
          })

          self.vars.filter1.click(function(event) {
             self.config.isFilter = 0;
             self.config.offset = 0;
             $('.js-contest-user').remove()
             self.loadingData(true);
          })
        },
 
        loadingData: function(isFirstAction) {

          let url = "load.php";

          if (self.config.isFilter === 1) {
             url = "load.php?popular=1";
          }

          $.ajax({
             method: "GET",
             url: url,
             data: {
                limit: self.config.limit,
                offset: self.config.offset,
             }
          })
          .done(function(data) {

             let dataObj = JSON.parse(data);

             console.log(dataObj);

             self.createUsers(dataObj);
             self.config.offset += self.config.limit

             if (isFirstAction) {
               //  DownloadImage.init();
             } else {
               //  DownloadImage.getRender();
             }

             Likes.init();

             if (dataObj.length !== self.config.limit) {
                self.vars.buttonInitInfinity.hide();
             }
          });
        },
 
        createUsers: function(dataObj) {

          let element = '';

          dataObj.forEach(function(item) {

             let username = item['name'].replace('@', '');
             let likeCount = Number(item['like_count']) + Number(item['like_count_inst']);
             let userId = item['id'];
             let imageUrl = item['image_url'];
             let postUrl = item['post_url'];
             let postId = item['id']; 

             element += `
             <li class="js-contest-user user_${userId}">
                <div class="contest-list__image">
                   <img src="${imageUrl}" 
                      alt="@${username}" 
                      title="@${username}" 
                      class="js-profile-img_${username}">
                </div>
                <div class="contest-list__vote icon-heart" data-like-count="${likeCount}" data-user-id="${userId}" data-post-id="${postId}">${likeCount}</div>
                <div class="contest-list__name"><a href="${postUrl}">Участник №${userId}</a></div>
                <button class="contest-list__btn" 
                   data-like-count="${likeCount}" 
                   data-user-id="${userId}"
                   data-post-id="${postId}"
                >Голосовать</button>
             </li>`;
          })

          self.vars.listWithUsers.append(element);
        },

        scrollClick: function() {
            $(document).on('click', 'a[href^="#"]', function(e) {
                e.preventDefault();
                let scrollTarget = $(this).attr('href');
                $('html, body').animate({scrollTop: $(scrollTarget).offset().top}, 500);
            })
        },
        toggleMobileMenu: function() {
           self.vars.mobileBtn.on('click', function(){
                if (self.vars.toggleFlag === false) {
                    $(this).parent().addClass('active');
                    self.vars.toggleFlag = true;
                } else {
                    $(this).parent().removeClass('active');
                    self.vars.toggleFlag = false;
                }
           });
        },
        scrollWindow: function() {
           console.log('INIT');
          let feature = (self.vars.headerHeight.outerHeight(true) + $('.header').outerHeight(true));
          if ($(window).offset().top > feature) {
              console.log('MORE');
          }
          console.log(feature);

          $(window).scroll(function(){

             let offsetTop = $(this).scrollTop();
              console.log(offsetTop);
             if (offsetTop > feature) {
                 self.toggleFooter(true);
             } else {
                 self.toggleFooter(false);
              }
          });
        },
        toggleFooter: function(offset) {
            console.log(offset);
           if (offset === true) {
            $(self.config.footerClass).addClass('active');
           } else {
               $(self.config.footerClass).removeClass('active');
           }
        }
    }
 })();

var SwiperSlider = (function() {

    let self;

    return {

        config: {
            mainSliderClass: '.js-swiper-slider'
        },

        vars: {},

        init: function() {
            self = this;
            self.initVars();
            self.swiper();
            //self.winnerSlider();
        },

        initVars: function () {
            self.vars = {
                mainSlider: $(self.config.mainSliderClass)
            }
        },
        swiper: function() {
            self.vars.mainSlider.each(function(index, value){
                let mySwiper = new Swiper(value, {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    pagination: {
                        el: '.swiper-pagination',
                        //clickable: true
                    },
                    navigation: {
                        nextEl: value.nextElementSibling.nextElementSibling,
                        prevEl: value.nextElementSibling,
                    },

                    breakpoints: {
                        // when window width is >= 320px
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 20,
                            freeMode: false
                        },
                        1024: {
                            slidesPerView: 1,
                            spaceBetween: 30,
                            freeMode: true,
                        }
                    }
                });
            });
        }
        // winnerSlider: function() {
        //     var mySwiper = new Swiper ('.js-swiper-winner', {
        //         pagination: {
        //             el: '.swiper-pagination',
        //         },
        //         navigation: {
        //             nextEl: '.swiper-button-next',
        //             prevEl: '.swiper-button-prev',
        //         },
        //     })
        // }
    }
})();

